import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();
import { IDevice } from "./IDevice";
import {IDeviceSvc,device_api} from "./IDeviceSvc"


export class DeviceSvc implements IDeviceSvc {

    public async get_maszyny(): Promise<IDevice[]> {
        const list = await bus.api(device_api.get_maszyny,  { });
        return list;
    }

     public async get_devices_short(limit:number) : Promise<IDevice[]>  { 
        const device_ret = await bus.api(device_api.get_devices_short,  { limit:limit });
        return device_ret;
    }

    public async find_by_id(_id:any) : Promise<IDevice | undefined>  { 
        const device_ret = await bus.api(device_api.find_by_id, { _id: _id });
        return device_ret;
    }

    public async create(device:IDevice): Promise<IDevice | undefined>  {
        const device_ret = await bus.api(device_api.create, device);
        return device_ret;
    }

    public async update(device:IDevice): Promise<IDevice | undefined>  {
        const device_ret = await bus.api(device_api.update, device);
        return device_ret;
    }

    public async delete(device:IDevice): Promise<IDevice | undefined>  {
        const device_ret = await bus.api(device_api.delete, device);
        return device_ret;
    }
  
}